module.exports = __webpack_public_path__ + "static/media/show-less.8f39a211.svg";